/* eslint-disable vue/no-reserved-component-names */
/* eslint-disable vue/multi-word-component-names */
import type { App } from "vue";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Checkbox from "primevue/checkbox";
import ColorPicker from "primevue/colorpicker";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import DialogService from "primevue/dialogservice";
import Dropdown from "primevue/dropdown";
import FileUpload from "primevue/fileupload";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Listbox from "primevue/listbox";
import MultiSelect from "primevue/multiselect";
import Password from "primevue/password";
import PickList from "primevue/picklist";
import RadioButton from "primevue/radiobutton";
import Rating from "primevue/rating";
import SelectButton from "primevue/selectbutton";
import Slider from "primevue/slider";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import ToggleButton from "primevue/togglebutton";
import Tooltip from "primevue/tooltip";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import Drawer from "primevue/drawer";
import Aura from "@primevue/themes/aura";
import DatePicker from "primevue/datepicker";
import Select from "primevue/select";
import StyleClass from "primevue/styleclass";
import AutoComplete from 'primevue/autocomplete';
import BlockUI from 'primevue/blockui';
import TabPanel from 'primevue/tabpanel';
import TabList from 'primevue/tablist';
import TabPanels from 'primevue/tabpanels';
import Tab from 'primevue/tab';
import Tabs from 'primevue/tabs';

export const installPrimeVuePlugin = (app: App) => {
  app.use(PrimeVue, {
    ripple: true,
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: '.app-dark'
      },
    },
  });

  app.use(ToastService);

  app.use(DialogService);
  app.use(ConfirmationService);

  app.directive("tooltip", Tooltip);
  app.directive("styleclass", StyleClass);

  app.component("IconField", IconField);
  app.component("InputIcon", InputIcon);
  app.component("Card", Card);
  app.component("Checkbox", Checkbox);
  app.component("ColorPicker", ColorPicker);
  app.component("FileUpload", FileUpload);
  app.component("InputMask", InputMask);
  app.component("InputNumber", InputNumber);
  app.component("InputSwitch", InputSwitch);
  app.component("InputText", InputText);
  app.component("Listbox", Listbox);
  app.component("MultiSelect", MultiSelect);
  app.component("Password", Password);
  app.component("PickList", PickList);
  app.component("RadioButton", RadioButton);
  app.component("Rating", Rating);
  app.component("SelectButton", SelectButton);
  app.component("Slider", Slider);
  app.component("Textarea", Textarea);
  app.component("ToggleButton", ToggleButton);
  app.component("Toast", Toast);
  app.component("Drawer", Drawer);
  app.component("DatePicker", DatePicker);
  app.component("Select", Select);
  app.component('Calendar', Calendar);
  app.component('AutoComplete', AutoComplete);
  app.component('TabPanel', TabPanel);
  app.component('TabList', TabList);
  app.component('TabPanels', TabPanels);
  app.component('Tab', Tab);
  app.component('Tabs', Tabs);
  app.component('BlockUI', BlockUI);
};
